import { keyframes } from '@emotion/react';
import {
  get,
  getColorsAndStatesByPath,
  Theme,
  ThemeUICSSObject,
} from '@apia/theme';
/* IMPORT HERE */

const dropzone: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'row',
  p: 4,
  borderRadius: 'default',
  padding: '0px!important',
  border: '1px solid',
  borderColor: 'palette.border.field',
  height: '51px',
  alignItems: 'center',
  width: '100%',
  background: 'palette.background.paper',
  position: 'relative',

  ':focus-within': {
    outlineColor: 'outlineColor',
    outlineWidth: '3px',
    outlineOffset: '-3px',
    outlineStyle: 'solid',
    borderColor: 'transparent',
  },

  '.dropzone': {
    backgroundSize: '200% 200%',
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'normal',
    border: 'none',
    wordBreak: 'break-word',
    overflow: 'hidden',
    margin: '3px',
    height: 'calc( 100% - 6px)',
    padding: 0,
    width: 'inherit',
    borderTopLeftRadius: '7px',
    borderBottomLeftRadius: '7px',
    backgroundImage: (t: Theme) =>
      `repeating-linear-gradient(45deg, 
  ${get(t, 'colors.dropzone.color') as string}, 
  ${get(t, 'colors.dropzone.color') as string} 3px, 
  ${get(t, 'colors.dropzone.backgroundColor') as string} 3px, 
  ${get(t, 'colors.dropzone.backgroundColor') as string} 12px)`,

    ':hover': {
      cursor: 'pointer',
      animation: `${keyframes({
        '100%': { backgroundPosition: '100% 100%' },
      })} 20s linear infinite`,

      '&:disabled': { animation: 'none' },
    },

    ':focus': {
      outline: 'none',
    },
    '.progressBar': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      borderRadius: '7px',
      backgroundColor: '#8080807a',
      transition: 'width 0.5s ease-in-out',
    },
  },

  '.info': {
    height: '100%',
    border: 'none',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
    boxShadow: 'none',
    width: '49px',

    ...getColorsAndStatesByPath('buttons.outline'),
    background: 'transparent',

    svg: {
      color: '#9f9f9f',
    },

    '&:focus': {
      outline: 'none',
    },
  },

  /* PREPEND HERE */
};

export default dropzone;
